/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import DataVaxiomPersonTitleSelect from 'DesignSystem/Data/DataVaxiom/DataVaxiomPerson/DataVaxiomPersonTitleSelect/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Details/Person/Title",
  onChange
  
}) {
let editProfessionalOtherPersonTitleValueData = fromData.useDataValue({ viewPath,
context: 'edit_professional',
path: 'other.person.title',
})
let editProfessionalOtherPersonTitleChangeData = fromData.useDataChange({ viewPath,
context: 'edit_professional',
path: 'other.person.title',
})
  return (<React.Fragment
>
<DataVaxiomPersonTitleSelect
  viewPath={`${viewPath}/DataVaxiomPersonTitleSelect`}
 size="medium"
 data="edit_professional.other.person.title"
 value={editProfessionalOtherPersonTitleValueData}
 onChange={editProfessionalOtherPersonTitleChangeData}
/>
{children}
</React.Fragment>)
}